// Reviews.io rating snippets, moved out of layout/theme.liquid.
// Loaded with defer. Product pages load the widget straight away; elsewhere it waits for
// the first scroll to keep it off the critical path. See data-load-immediately on the script tag.
(function () {
  const loadImmediately = document.currentScript?.dataset.loadImmediately === 'true';

  // 1) Load the rating snippet widget
  function injectReviewsIo() {
    if (typeof doRatingSnippetReq === 'function') {
      window.removeEventListener('scroll', injectReviewsIo);
      return;
    }

    const snippetDiv = document.querySelector('.ruk_rating_snippet');
    if (!snippetDiv || snippetDiv.dataset.loading === 'true' || snippetDiv.dataset.initialized === 'true') {
      return;
    }

    window.removeEventListener('scroll', injectReviewsIo);
    snippetDiv.dataset.loading = 'true';
    let originalContent = snippetDiv.innerHTML;

    // Revert any changes made to the snippet before the widget reports it's ready
    function restoreOriginalContent() {
      if (snippetDiv.innerHTML !== originalContent) {
        snippetDiv.innerHTML = originalContent;
      }
    }

    const observer = new MutationObserver(restoreOriginalContent);
    observer.observe(snippetDiv, { childList: true });

    const script = document.createElement('script');
    script.src = 'https://widget.reviews.io/rating-snippet/dist.js';
    script.async = true;
    script.onload = function () {
      ratingSnippet('ruk_rating_snippet', {
        store: 'naturespy.org',
        color: '#0E1311',
        linebreak: true,
        usePolaris: true,
        enable_customer_location: false,
        enable_replies: true,
        text: 'Reviews',
        callback: function () {
          observer.disconnect();
          snippetDiv.dataset.initialized = 'true';
          delete snippetDiv.dataset.loading;
          originalContent = snippetDiv.innerHTML;
        },
      });
    };
    document.head.appendChild(script);

    const css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = 'https://widget.reviews.io/rating-snippet/dist.css';
    document.head.appendChild(css);

    // Trigger resize so carousels re-measure
    setTimeout(function () {
      window.dispatchEvent(new Event('resize'));
    }, 100);
  }

  if (loadImmediately) {
    injectReviewsIo();
  } else {
    window.addEventListener('load', function () {
      if (window.scrollY > 100) injectReviewsIo();
    });
    window.addEventListener('scroll', injectReviewsIo, { passive: true });
  }

  // 2) Make sure every snippet shows its "(XX Reviews)" count
  function ensureCount(snippetEl) {
    if (snippetEl.querySelector('.ruk-rating-snippet-count')) return;

    // Parse "123 Reviews" / "1,234 Reviews" from the snippet's title or aria-label
    const titleText = snippetEl.getAttribute('title') || snippetEl.getAttribute('aria-label') || '';
    const match = titleText.match(/([\d,]+)\s+Reviews?/i);
    if (!match) return;

    const span = document.createElement('span');
    span.className = 'ruk-rating-snippet-count';
    span.textContent = '(' + match[1] + ' Reviews)';
    snippetEl.append(document.createElement('br'), span);
  }

  function seedAllCounts() {
    document.querySelectorAll('.ruk_rating_snippet').forEach(ensureCount);
  }

  // Snippets can be added later (e.g. product grids rendered by JS)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof Element)) return;
        if (node.matches('.ruk_rating_snippet')) ensureCount(node);
        node.querySelectorAll('.ruk_rating_snippet').forEach(ensureCount);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  seedAllCounts();
  // Fallback for snippets that appear after load
  window.addEventListener('load', function () {
    setTimeout(seedAllCounts, 300);
  });

  // 3) When a snippet is clicked, sort the Reviews.io lightbox by "Highest Rating"
  let pollTimer = null;

  function sortByHighest(container) {
    const trigger = container.querySelector('.c-filters__triggerButton');
    if (!trigger) return;
    if (trigger.getAttribute('aria-expanded') === 'false') trigger.click();

    const dropdown = container.querySelector('.js-demo-sortdropdown');
    if (!dropdown) return;
    dropdown.querySelectorAll('.R-DropUpDownMenu__item').forEach(function (item) {
      if (item.textContent.trim() === 'Highest Rating') item.click();
    });
  }

  function waitForLightbox() {
    clearInterval(pollTimer);
    let attempts = 0;
    // Check every 100ms (up to 3s) for the lightbox to be visible
    pollTimer = setInterval(function () {
      attempts += 1;
      const container = document.getElementById('reviews_container');
      if (container && getComputedStyle(container).display !== 'none') {
        clearInterval(pollTimer);
        // Give the sort dropdown time to render
        setTimeout(function () {
          sortByHighest(container);
        }, 200);
      } else if (attempts >= 30) {
        clearInterval(pollTimer);
      }
    }, 100);
  }

  document.body.addEventListener('click', function (e) {
    const snippetEl = e.target.closest('.ruk_rating_snippet');
    if (!snippetEl) return;
    ensureCount(snippetEl);
    waitForLightbox();
  });
})();
